import React from 'react';
import classNames from 'classnames';
import { PerfectScrollbar } from '../../../../shared/ReactPerfectScrollbar';

function DiagnosticPackageTableBody({ children, className, style }) {
  return (
    <PerfectScrollbar className={classNames('rt-tbody', className)} style={style}>
      {children}
    </PerfectScrollbar>
  );
}

export default DiagnosticPackageTableBody;
